import React from 'react'

interface CloudinaryEmbedInterface {
  (props: { video_embed: string }): JSX.Element
}

const CloudinaryEmbed: CloudinaryEmbedInterface = ({ video_embed }) => {
  // cloudinary embed manipulation to add start offset of 8 seconds, change mp4 to jpg for use in <video poster=""> attribute
  const parenthSplit = video_embed.split('/')
  const individualParts = parenthSplit.indexOf('upload')
  parenthSplit.splice(individualParts, 1, 'upload/so_8')
  const newCloudinaryUrl = parenthSplit.join('/')
  const finalCloudinaryUrl = newCloudinaryUrl.replace('.mp4', '.jpg')
  return (
    <div className="overflow-hidden rounded-2xl bg-gray-1100">
      <video
        poster={`${finalCloudinaryUrl}`}
        controls
        src={video_embed}
        className="block w-full"
        style={{
          aspectRatio: 'var(--aspect-ratio-video)'
        }}
      />
    </div>
  )
}

export default CloudinaryEmbed
